import React, { useEffect, useState } from "react";
import styles from "./Banner.module.css";
import { useAuth } from "../../context/AuthContext";
import BannerImg from "../../assets/images/expertBanner.png";

export default function Banner({ userType, onSearch, searchValue }) {
  const { setAuthModal } = useAuth();
  const [draft, setDraft] = useState(searchValue || "");

  // Sync when role changes (mentor ⇄ author)
  useEffect(() => {
    setDraft(searchValue || "");
  }, [searchValue]);

  const handleSearch = () => {
    onSearch(draft.trim());
  };

  const handleReset = () => {
    setDraft("");
    onSearch("");
  };

  return (
    <section className={styles.banner}>
      <div className={styles.container}>
        <div className={styles.left}>
          <h2>Search for {userType}</h2>

          <div className={styles.searchBox}>
            <input
              type="text"
              placeholder="Search Expert"
              value={draft}
              onChange={(e) => setDraft(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleSearch();
              }}
            />
            {draft ? (
              <button
                type="button"
                className={styles.clearBtn}
                onClick={handleReset}
                aria-label="Clear search"
              >
                ×
              </button>
            ) : null}
            <button type="button" className={styles.searchBtn} onClick={handleSearch} />
          </div>
        </div>

        <div className={styles.middle}>
        {userType === "Mentors"? 
          <p>
        <strong>  Lead. Mentor. Inspire.</strong><br/>
        
        The IMPARC Mentorship Program connects you with scholars worldwide, offering opportunities for collaboration, academic visibility, exclusive events, and impactful contributions to global research and education. </p> :
          <p><strong>Publish. Learn. Grow.</strong><br/>
          Become an IMPARC Research Associate to publish your first paper for free, enjoy exclusive discounts on books & journals, gain expert guidance in research writing and analysis, and access global opportunities for recognition.</p>
}
        </div>

        <div className={styles.right}>
          <img src={BannerImg} alt="Banner" />
        </div>
      </div>
    </section>
  );
}
